import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { orderGroupIdZodSchema } from "@@/shared/order-groups/order-group-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { onPremisePaymentTypeZodEnum } from "../on-premise-payment-type";

const initiateOnPremisePaymentCommandZodObject = z.object({
    _id: idZodSchema,
    _createdAt: isoAndUnixZodSchema,
    _type: z.literal("INITIATE_ON_PREMISE_PAYMENT_COMMAND"),
    orderGroupId: orderGroupIdZodSchema,
    paymentType: z.enum(["on_premise_pay_later", "on_premise_paid"]),
});

type InitiateOnPremisePaymentCommand = z.infer<
    typeof initiateOnPremisePaymentCommandZodObject
>;
const initiateOnPremisePaymentCommandZodSchema: z.ZodSchema<InitiateOnPremisePaymentCommand> =
    initiateOnPremisePaymentCommandZodObject;

const initiateOnPremisePaymentCommandResponseZodObject = z.object({
    _id: idZodSchema,
    _createdAt: isoAndUnixZodSchema,
    _type: z.literal("INITIATE_ON_PREMISE_PAYMENT_COMMAND_RESPONSE"),
    orderGroupId: orderGroupIdZodSchema,
    paymentType: onPremisePaymentTypeZodEnum,
});
type InitiateOnPremisePaymentCommandResponse = z.infer<
    typeof initiateOnPremisePaymentCommandResponseZodObject
>;
const initiateOnPremisePaymentCommandResponseZodSchema: z.ZodSchema<InitiateOnPremisePaymentCommandResponse> =
    initiateOnPremisePaymentCommandResponseZodObject;

type FactoryParams = Except<
    InitiateOnPremisePaymentCommand,
    "_id" | "_type" | "_createdAt"
>;
type ResponseFactoryParams = Except<
    InitiateOnPremisePaymentCommandResponse,
    "_id" | "_type" | "_createdAt"
>;
const initiateOnPremisePaymentCommandFactory = (params: FactoryParams) => {
    const initiateOnPremisePaymentCommand: InitiateOnPremisePaymentCommand = {
        ...params,
        _id: generateId({ prefix: "initiate_onpremise_payment_command__" }),
        _type: "INITIATE_ON_PREMISE_PAYMENT_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return initiateOnPremisePaymentCommand;
};
const initiateOnPremisePaymentCommandResponseFactory = (
    params: ResponseFactoryParams,
) => {
    const initiateOnPremisePaymentCommandResponse: InitiateOnPremisePaymentCommandResponse =
        {
            ...params,
            _id: generateId({
                prefix: "initiate_onpremise_payment_command_response__",
            }),
            _type: "INITIATE_ON_PREMISE_PAYMENT_COMMAND_RESPONSE",
            _createdAt: nowIsoAndUnix(),
        };
    return initiateOnPremisePaymentCommandResponse;
};

export {
    initiateOnPremisePaymentCommandFactory,
    initiateOnPremisePaymentCommandResponseFactory,
    initiateOnPremisePaymentCommandResponseZodSchema,
    initiateOnPremisePaymentCommandZodSchema,
};
export type {
    InitiateOnPremisePaymentCommand,
    InitiateOnPremisePaymentCommandResponse,
};
